<template>
 <div id="layoutAuthentication" >
            <div id="layoutAuthentication_content">
                <main>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-5">
                                <div class="card shadow-lg border-0 rounded-lg mt-5">
                                    <div class="card-header"><h3 class="text-center font-weight-light my-4">Login</h3></div>
                                    <div class="card-body">
                                        <form @submit.prevent="login_user">
                                            <div class="form-group"><label class="small mb-1" for="inputEmailAddress">Email</label>
                                                <input class="form-control py-4" id="inputEmailAddress" type="email" placeholder="Enter email address"  v-model="form.email" required/>
                                            </div>
                                            <div class="form-group"><label class="small mb-1" for="inputPassword" >Password</label>
                                                <input class="form-control py-4" id="inputPassword" type="password" placeholder="Enter password" v-model="form.password" required/>
                                            </div>
                                            <div class="form-group">
                                            </div>
                                            <p v-if="message"  class="text-center" style="color: red"> {{message}} </p>
                                            <div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
                                                <a class="small" href="/request_password_recovery">Forgot Password?</a>
                                                <button type="submit" class="btn btn-primary" >Login
                                                    <div class="spinner-grow" role="status" v-if="loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </button>
                                                </div>
                                        </form>
                                    </div>
                                    <div class="card-footer text-center">
                                        <div class="small"><a href="/user/register ">Need an account? Sign up!</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            <div id="layoutAuthentication_footer">
                <footer class="py-4 bg-light mt-5">
                    <div class="container-fluid">
                        <div class="d-flex align-items-center justify-content-between small">
                            <div class="text-muted">Copyright &copy; ActionCommons 2020</div>
                            <div>
                                <a href="#">Privacy Policy</a>
                                &middot;
                                <a href="#">Terms &amp; Conditions</a>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
</template>
<script>
import url from '../URL'
//import AppNavigation from '../components/AppNavigation'
export default {
    data() {
        return {
            components: {
               // AppNavigation
            },
            form : {
                email:'',
                password:'',
            },
            loading:false,
            message:''
        }
    },
    methods:{
       async login_user(){

            this.loading = true
            this.message = ''
            const data = {
                email: this.form.email,
                password: this.form.password
            }
            
            try {
            const response = await this.$http.post(`${this.apiurl}/api/actioncommons/contributor/login`,data)

                 if(response.status === 200) {
                     localStorage.setItem('userToken', response.data.token)
                     console.log(response.data.token)
                     this.loading = false;
                     this.$router.push('/user/home')
                 }
             
            } catch( err) {
                    if(err.response.status === 422) {
                        this.message = "Incorrect Email and Password."
                        this.loading = false

                    }
            
            
        }

        }
    },
    computed: {
    apiurl() {
        return url()
    } 
}
}
</script>
<style>
</style>